import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { SocketProvider } from "./context/SocketContext";

import Homepage from "./components/basic/homepage/homepage";
import Dashboard from "./components/dashboard/backbone";
import TraineeRegister from "./components/trainee/register/traineeregister";
import MainPortal from "./components/trainee/examPortal/portal";
import Answer from "./components/trainee/answersheet/answer";
import Forgot from "./auth/forgotpassword/index";
import ResetPassword from "./auth/forgotpassword/ResetPassword";

import "react-quill/dist/quill.snow.css";
import "./App.css";



function MainApp(){
return (
    <Provider store={store}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/admin" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/user" element={<Dashboard />} />
          <Route path="/user/:options" element={<Dashboard />} />
          <Route path="/register" element={<TraineeRegister />} />
          <Route path="/forgot-password" element={<Forgot />} />
          <Route path="/reset-password/:id" element={<ResetPassword />} />
          <Route path="/trainee/taketest" element={<MainPortal />} />
          <Route
            path="/trainee/taketest/:testid/:traineeid"
            element={<Answer />}
          />
        </Routes>
      </HashRouter>
    </Provider>
  );
}

function App() {
  return(
    <SocketProvider>
      <MainApp/>
    </SocketProvider>
  )
}


export default App;
